export enum ProjectUpdateNotificationFieldEnum {
    NAME,
    COMPANY_NAME,

    INDUSTRY_SECTOR,
    DEPARTMENT,
    EMPLOYEE_COUNT,
    COMPANY_STREET,
    COMPANY_ZIP,
    COMPANY_CITY,
    COMPANY_COUNTRY,
    QUOTE_CLOSING_DATE,
    COMMENT,
    IS_TENDER,
    TENDER_DOCUMENTS,
    PRODUCT_DISTRIBUTOR,
    SECONDARY_PRODUCT_DISTRIBUTOR,
    PRODUCT_ROLLOUT_START,
    PRODUCT_ROLLOUT_END,
    PRODUCTS,
    SUPPLY_DISTRIBUTOR,
    SECONDARY_SUPPLY_DISTRIBUTOR,
    SUPPLY_ACQUISITION_TYPE,
    SUPPLY_ROLLOUT_START,
    SUPPLY_ROLLOUT_END,
    TIME_PERIOD,
    SUPPLIES
}


